/* v8 ignore start */
import { createApiOf } from '@/package';

import axiosInstance from './baseInstance';

const apiOf = createApiOf(axiosInstance);

export { apiOf };
/* v8 ignore end */
